function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  d: "M12.67 7.12V0H0v12.88h7.33V20H20V7.12h-7.33zm-11.34 4.4V1.37h10v5.76H8.56l-1.4-4.07H5.5L3.43 9.12h1.4l.35-.98h2.16v3.4h-6zm5.7-4.74h-1.4l.7-2 .7 2zm11.64 11.86h-10V8.47h10v10.17zM12.56 14.6c.14.22.28.42.43.6h-.02c-.48.26-1.03.4-1.65.4v1.35c1 0 1.9-.27 2.67-.8.76.53 1.66.8 2.67.8V15.6c-.62 0-1.17-.14-1.65-.4.15-.2.28-.38.4-.58l.02-.02c.38-.62.66-1.3.83-2v-.06H17V11.2h-2.33v-1.03h-1.34v1.02H11v1.34h.72c.18.74.46 1.44.86 2.1l-.02-.04zm2.34-2.06c-.14.48-.35.94-.6 1.36v-.02c-.1.16-.2.3-.3.45-.1-.13-.2-.26-.28-.4v-.02c-.27-.4-.47-.85-.6-1.32l-.02-.04h1.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#15A9E1",
  fillRule: "evenodd",
  d: "M25.16 7.12c.2-.17.48-.16.66.04l4.22 4.7 4.23-4.7c.18-.2.47-.2.66-.04.2.17.2.47.04.66l-4.56 5.06c-.1.1-.22.16-.36.16-.13 0-.26-.05-.36-.16l-4.56-5.06c-.17-.2-.16-.5.04-.66z",
  clipRule: "evenodd"
});

var SvgLanguage = function SvgLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/language.d2c00c77.svg";
export { ForwardRef as ReactComponent };